import React, { useRef, useState } from "react";
import { TextField, Button, Grid, Select, MenuItem, Typography, InputLabel, Checkbox, FormControl } from '@mui/material';
import swal from 'sweetalert';
import { DatosProveedores, ingresoDOCXWorkmanagerFlujo } from '../FunctionLogin.js'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { useNavigate } from 'react-router-dom';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Alert
} from '@mui/material';
import SignatureCanvas from "react-signature-canvas";
import { Directions } from "@mui/icons-material";
import { generarPDF } from './personaNaturalPDF.js'


export default function PersonaNatural({ solicitanteValue, procesoValue, sucursalValue, servicioValue, tipoNegociacionValue, tipoNegociacion2Value, idregisto, nombreFormato, cargoFormato, tipoPersonaRegistro, tipoVinculacionRegistro }) {

    const sigPad = useRef({});



    const [tableData, setTableData] = useState([{ tipoProducto: '', nombreProducto: '', entidad: '', monto: '', ciudad: '', pais: '', moneda: '' }]);

    const handleCopyRow = () => {
        setTableData((prevTableData) => {
            const lastRow = prevTableData[prevTableData.length - 1];
            const newRow = { ...lastRow };
            Object.keys(newRow).forEach((key) => {
                newRow[key] = '';
            });
            return [...prevTableData, newRow];
        });
    };


    const handleCellChange = (event, rowIndex, fieldName) => {
        const updatedTableData = [...tableData];
        updatedTableData[rowIndex][fieldName] = event.target.value;
        setTableData(updatedTableData);
    };


    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [firmaFile, setFirmaFile] = useState(null);
    const [rutFile, setRutFile] = useState(null);
    const [camaraComercioFile, setCamaraComercioFile] = useState(null);
    const [ccIdRepresentanteFile, setCcIdRepresentanteFile] = useState(null);
    const [polizaSeguroFile, setPolizaSeguroFile] = useState(null);
    const [certificadosCinco, setCertificadosCincoFile] = useState(null);
    const [certificadoActuales, setCertificadoActualesFile] = useState(null);
    const [referenciasPersonalesFile, setReferenciasPersonalesFile] = useState(null);
    const [estadosFinancierosFile, setEstadosFinancierosFile] = useState(null);
    const [certificacionBancariaFile, setCertificacionBancariaFile] = useState(null);
    const [nombres, setNombres] = useState('');
    const [nit, setNit] = useState('');
    const [apellidos, setApellidos] = useState('');
    const [tipoIdentificacion, setTipoIdentificacion] = useState('');
    const tipoIdentificacionValues = [
        "C.C",
        "C.E",
        "ID",
    ];

    const [numeroIdentificacion, setNumeroIdentificacion] = useState('');
    const [expedidaEn, setExpedidaEn] = useState('');
    const [direccion, setDireccion] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [codigoCIIU, setCodigoCIIU] = useState('');
    const [email, setEmail] = useState('');
    const [ocupacionProfesion, setOcupacionProfesion] = useState('');
    const [nombreEmpresa, setNombreEmpresa] = useState('');
    const [cargo, setCargo] = useState('');
    const [tipoEmpresa, setTipoEmpresa] = useState('');
    const tipoEmpresaValues = [
        "Publica",
        "Privada",
        "Mixta",
    ];

    const [categoria, setCategoria] = useState('');
    const [tipoProducto, setTipoProducto] = useState('');

    const [tipoTransaccion, setTipoTransaccion] = useState('');
    const tipoTransaccionValue = [
        "Ninguna",
        "Importación",
        "Exportación",
        "Inversiones",
        "Préstamos",
        "Transferencias",
        "Otros",
    ];
    const options = [
        'SERVICIOS DE TRANSPORTE NACIONAL',
        'SERVICIOS INFORMÁTICOS',
        'SERVICIOS MECANIZADOS O METALMECÁNICOS',
        'SERVICIOS DE AGENCIA DE ADUANAS',
        'SERVICIOS DE TRANSPORTE INTERNACIONAL',
        'SERVICIOS DE PAQUETEO',
        'SERVICIOS DE INGENIERÍA',
        'SERVICIOS LEGALES',
        'SERVICIOS CONTABLES E IMPUESTOS',
        'SERVICIOS LOGÍSTICOS',
        'SUMINISTROS MATERIAS PRIMAS',
        'SUMINISTROS MATERIAL DE EMPAQUE',
        'SUMINISTROS REPUESTOS',
        'SUMINISTROS MAQUINARIA Y EQUIPOS PARA LA VENTA',
        'SUMINISTROS DE CONSUMIBLES Y ACCESORIOS PARA LA VENTA',
    ];


    let date = new Date();
    const [fechainicial, setfechainicial] = React.useState(dayjs(date.toISOString().split('T')[0]));

    const [fechainicialCompania, setfechainicialCompania] = React.useState(dayjs(date.toISOString().split('T')[0]));



    const [direccionEmpresa, setDireccionEmpresa] = useState('');
    const [paisCiudad, setPaisCiudad] = useState('');
    const [telefonoEmpresa, setTelefonoEmpresa] = useState('');
    const [emailEmpresa, setEmailEmpresa] = useState('');
    const [otroCertificado, setOtroCertificado] = useState('');
    const [certificadoNinguno, setCertificadoNinguno] = useState(false);

    const [otroLavadoDeActivos, setOtroLavadoDeActivos] = useState('');



    const [nombreComercial, setNombreComercial] = useState('');
    const [nombreContabilidad, SetNombreContabilidad] = useState('');
    const [nombreTesoreria, setNombreTesoreria] = useState('');
    const [nombreComercialCorreo, setNombreComercialCorreo] = useState('');
    const [nombreContabilidadCorreo, SetNombreContabilidadCorreo] = useState('');
    const [nombreTesoreriaCorreo, setNombreTesoreriaCorreo] = useState('');


    const [terrorismo, setTerrorismo] = useState(false);
    const [eticaEmpresarial, setEticaEmpresarial] = useState(false);

    const [direccionOficinaPrincipal, setDireccionOficinaPrincipal] = useState('');
    const [ciudadOficinaPrincipal, setCiudadOficinaPrincipal] = useState('');
    const [paisOficinaPrincipal, setPaisOficinaPrincipal] = useState('');
    const [telefonoPrincipal, setTelefonoPrincipal] = useState('');
    const [correoComercial2, setCorreoComercial2] = useState('');
    const [direccionSucursal, setDireccionSucursal] = useState('');
    const [ciudadSucursal, setCiudadSucursal] = useState('');
    const [paisSucursal, setPaisSucursal] = useState('');
    const [telefonoSucursal, setTelefonoSucursal] = useState('');
    const [correoPagos, setCorreoPagos] = useState('');

    const [certificadoBasc, setCertificadoBasc] = useState(false);
    const [certificadoIso, setCertificadoIso] = useState(false);
    const [certificadoOea, setCertificadoOea] = useState(false);

    const [funcionarioPublico, setFuncionarioPublico] = useState(false);
    const [administraRecursosPublicos, setAdministraRecursosPublicos] = useState(false);
    const [reconocimientoPublico, setReconocimientoPublico] = useState(false);

    const [granContribuyenteCheck, setGranContribuyenteCheck] = useState(false);
    const [granContribuyenteResolucion, setGranContribuyenteResolucion] = useState("");
    const [fechainicialGranContribuyente, setFechainicialGranContribuyente] = React.useState(dayjs(date.toISOString().split('T')[0]));
    const [opcionSeleccionada, setOpcionSeleccionada] = useState('');


    const [fechaRenta, setFechaRenta] = React.useState(dayjs(date.toISOString().split('T')[0]));
    const [responsableRentaCheck, setResponsableRentaCheck] = useState(false);
    const [rentaCheck, setRentaCheck] = useState(false);
    const [regimenCheck, setReegimenCheck] = useState(false);
    const [rentaResolucion, setRentaResolucion] = useState("");

    const [ciudadIca, setCiudadIca] = useState("");
    const [tarifaPorMil, setTarifaPorMil] = useState("");
    const [autoRetenedorCheckIca, setAutoRetenedorCheckIca] = useState(false);
    const [icaResolucion, setIcaResolucion] = useState("");
    const [fechaIca, setFechaIca] = React.useState(dayjs(date.toISOString().split('T')[0]));
    const [totalActivos, setTotalActivos] = useState("");
    const [totalPasivos, setTotalPasivos] = useState("");
    const [patrimonio, setPatrimonio] = useState("");
    const [checkRealizaTransaccionesMonedaExtra, setCheckRealizaTransaccionesMonedaExtra] = useState(false);
    const [otroTipo, setOtroTipo] = useState("");
    const [nombreSolicitante, setNombreSolicitante] = useState("");
    const [Firma, setFirma] = useState("");
    const [documentoFirma, setDocumentoFirma] = useState("");
    const [EmpleadoTalsa, setEmpleadoTalsa] = useState("");




    const handleRutChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setRutFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Valide la información, ya que solo se acepta PDF!", "Valide la información!", "warning");
        }

    };

    const handleOpcionSeleccionadaChange = (event) => {
        setOpcionSeleccionada(event.target.value);
    };

    const handleCamaraComercioChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCamaraComercioFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Valide la información, ya que solo se acepta PDF!", "Valide la información!", "warning");
        }
    };

    const handleCcIdRepresentanteChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCcIdRepresentanteFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Valide la información, ya que solo se acepta PDF!", "Valide la información!", "warning");
        }
    };
    const handlePolizaSeguroChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setPolizaSeguroFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Valide la información, ya que solo se acepta PDF!", "Valide la información!", "warning");
        }
    };
    const handleReferenciasPersonalesChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setReferenciasPersonalesFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Valide la información, ya que solo se acepta PDF!", "Valide la información!", "warning");
        }
    };



    const handleCertificadosCincoChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCertificadosCincoFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Valide la información, ya que solo se acepta PDF!", "Valide la información!", "warning");
        }
    };


    const handleCertificadoActualesChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCertificadoActualesFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Valide la información, ya que solo se acepta PDF!", "Valide la información!", "warning");
        }
    };

    const handleEstadosFinancierosChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setEstadosFinancierosFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Valide la información, ya que solo se acepta PDF!", "Valide la información!", "warning");
        }
    };

    const handleCertificacionBancariaChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCertificacionBancariaFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Valide la información, ya que solo se acepta PDF!", "Valide la información!", "warning");
        }
    };


    const [currentDate, setCurrentDate] = useState(new Date());

    React.useEffect(() => {
        setCurrentDate(new Date());
    }, []);

    const handleSubmit = async (event) => {
        setLoading(true)
        event.preventDefault();
        try {
            if (firmaFile == null) {
                swal("Error", "Debe firmar el documento!", "warning");
                setLoading(false)
                return
            }
            const data = {
                NOMBREINFORMACIONGENERAL: nombres,
                APELLIDOINFORMACIONGENERAL: apellidos,
                TIPODEDOCUMENTOINFORMACIONGENERAL: tipoIdentificacion,
                NUMEROINFORMACIONGENERAL: numeroIdentificacion,
                EXPEDIDAEN: expedidaEn,
                FECHADEEXPEDICION: new Date(fechainicial).toISOString().split('T')[0],
                DIRECCIONIFORMACIONGENERAL: direccion,
                CIUDADINFORMACIONGENERAL: ciudad,
                TELEFONOINFORMACIONGENERAL: telefono,
                CELULARINFORMACIONGENERAL: celular,
                CODIGOCIIUACTIVIDAD: codigoCIIU,
                EMAILACTIVIDAD1: email,
                OCUPACIONACTIVIDAD: ocupacionProfesion,
                EMPRESAACTIVIDAD: nombreEmpresa,
                CARGOACTIVIDAD: cargo,
                TIPODEEMPRESAACTIVIDAD: tipoEmpresa,
                DIRECCIONEMPRESAACTVIDAD: direccionEmpresa,
                PAISACTIVIDAD: paisCiudad,
                TELEFONOACTIVIDAD: telefonoEmpresa,
                EMAILACTIVIDAD: emailEmpresa,
                BASC: certificadoBasc,
                ISO28001: certificadoIso,
                OEA: certificadoOea,
                OTROSCERTIFICADOSACTIVIDAD: otroCertificado,
                NINGUNCERTIFICADO: certificadoNinguno,
                FUNCIONARIOPUBLICO: funcionarioPublico,
                RECURSOSPUBLICOS: administraRecursosPublicos,
                RECONOCIMIENTOPUBLICO: reconocimientoPublico,
                GRANCONTRIBUYENTE: granContribuyenteCheck,
                RESOLUCIONGRANCONTRIBUYENTE: granContribuyenteResolucion,
                FECHAGRANCONTRIBUYENTE: new Date(fechainicialGranContribuyente).toISOString().split('T')[0],
                RESPONSABLEDERENTA: rentaCheck,
                RESOLUCIONRENTA: rentaResolucion,
                FECHARENTA: new Date(fechaRenta).toISOString().split('T')[0],
                CIUDADICA: ciudadIca,
                TARIFAX1000: tarifaPorMil,
                AUTORETENEDORICA: autoRetenedorCheckIca,
                RESOLUCIONICA: icaResolucion,
                FECHAICA: new Date(fechaIca).toISOString().split('T')[0],
                TOTALACTIVOS: totalActivos,
                TOTALPASIVOS: totalPasivos,
                PATRIMINIO: patrimonio,
                OPERACIONESEXTRANJERAS: checkRealizaTransaccionesMonedaExtra,
                TIPODEOPERACION: tipoTransaccion,
                OTROTIPODEOPERACION: otroTipo,
                TABLADEPRODUCTOS: JSON.stringify(tableData),
                NOMBRESOLICITANTE: nombreSolicitante,
                FIRMASOLICITANTE: Firma,
                DOCUMENTOSOLICITANTE: documentoFirma,
                RAZONSOCIAL: nombreEmpresa,
                NITDETALLEACTIVIDAD: nit,
                ID: numeroIdentificacion,
                ACTIVIDADECONOMICA: opcionSeleccionada,
                DIRECCIONOFINAPRINCIPAL: direccionOficinaPrincipal,
                CIUDADOFICINAPRINCIPAL: ciudadOficinaPrincipal,
                PAISOFICINAPRINCIPAL: paisOficinaPrincipal,
                TELEFONOPRINCIPAL: telefonoPrincipal,
                CORREOCOMERCIAL1: correoComercial2,
                DIRECCIONSUCURSAL: direccionSucursal,
                CIUDADSUCURSAL: ciudadSucursal,
                PAISSUCURSAL: paisSucursal,
                TELEFONOSUCURSAL: telefonoSucursal,
                CORREOPAGOS: correoPagos,
                NOMBRESYAPELLIDOSDEQUIENDILIGENCIAELFORMATO: nombreFormato,
                CARGOFORMATO: cargoFormato,
                NOMBRECOMERCIAL: nombreComercial,
                CORREOCOMERCIAL2: nombreComercialCorreo,
                NOMBRECONTABILIDAD: nombreContabilidad,
                CORREOCONTABILIDAD: nombreContabilidadCorreo,
                NOMBRETESORERIA: nombreTesoreria,
                CORREOTESORERIA: nombreTesoreriaCorreo,
                LAVADODEACTIVOS: terrorismo,
                LAVADODEACTIVOSOTROS: otroLavadoDeActivos,
                ETICAEMPRESARIAL: eticaEmpresarial ? "Aceptado" : "Rechazado",
                FECHACONSTITUCION: new Date(fechainicialCompania).toISOString().split('T')[0],
                CATEGORIAPRODUCTO: categoria,
                TIPODEPRODUCTO: tipoProducto,
                TIPOPROVEEDOR: tipoPersonaRegistro,
                NIT: nit,
                REGIMEN: String(regimenCheck),  // WorkManager espera 'true' o 'false'
                TIPO_VINCULACION: tipoVinculacionRegistro
            };

            const files = [
                { base64: rutFile, tipo: "RutProveedor", ext: ".pdf" },
                { base64: camaraComercioFile, tipo: "camaraComercioFile", ext: ".pdf" },
                { base64: ccIdRepresentanteFile, tipo: "FotocopiadeCC", ext: ".pdf" },
                { base64: certificacionBancariaFile, tipo: "CertificadoBancario", ext: ".pdf" },
                { base64: polizaSeguroFile, tipo: "DeclaraciónRenta", ext: ".pdf" },
                { base64: firmaFile, tipo: "Firma", ext: ".png" },
                //{ base64: `data:application/pdf;base64,${await generarPDF(solicitanteValue, procesoValue, sucursalValue, servicioValue, tipoNegociacionValue, tipoNegociacion2Value, idregisto, data, firmaFile)}`, tipo: "archivoproveedor", ext: ".pdf" }
            ];

            const jsonData = JSON.stringify(data);
            const productos = JSON.stringify(tableData)
            console.log(productos)
            var raw = JSON.stringify({
                "datos": `${jsonData}`,
                "firma": `${firmaFile}`,
                "productos": `${productos}`
            });
            //console.log(firmaFile)
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };
            //fetch("https://consumos.talsa.com.co/api/talsa/pdf/v1/pdfproveedornacional", requestOptions)
            fetch("https://consumos.talsa.com.co/api/talsa/pdf/v1/pdfproveedornacional", requestOptions)
                .then(response => {
                    if (response.status == 200) {
                        return response.text(); // Return the response text to the next then
                    } else {
                        setLoading(false)
                        swal("Error", "El documento no fue creado con exito", "error");
                        throw new Error('El documento no fue creado con exito');
                    }
                })
                .then(responseText => {
                    const responseJson = JSON.parse(responseText);
                    const base64 = responseJson.base64;
                    console.log(base64)
                    DatosProveedores(solicitanteValue, procesoValue, sucursalValue, servicioValue, tipoNegociacionValue, tipoNegociacion2Value, idregisto, files, data).then((result) => {
                        ingresoDOCXWorkmanagerFlujo(base64, result, "archivoproveedor").then(() => {
                            swal("Exitoso", "El documento fue creado con exito", "success");
                            setLoading(false)
                            navigate("/proveedores/cerrar")
                        });
                    })
                })
        } catch (error) {
            console.error("Error capturado en handleSubmit:", error);
            swal("Error de ejecución", "Ocurrió un error antes de enviar los datos. Revisa la consola.", "error");
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} noValidate>


            <Grid item xs={12}>
                <Typography variant="h6">Información General</Typography>
            </Grid>

            <Grid container spacing={2}>

                {/* Campos adicionales */}
                <Grid item xs={12} sm={4}>
                    <TextField
                        required
                        fullWidth
                        label="Nombres"
                        value={nombres}
                        onChange={(e) => setNombres(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={5}>
                    <TextField
                        required
                        fullWidth
                        label="Apellidos Completos"
                        value={apellidos}
                        onChange={(e) => setApellidos(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControl fullWidth>
                        <InputLabel id="tipo-identificacion-label">Tipo de ID</InputLabel>
                        <Select
                            labelId="tipo-identificacion-label"
                            required
                            fullWidth
                            label="Tipo de Identificación"
                            value={tipoIdentificacion}
                            onChange={(e) => setTipoIdentificacion(e.target.value)}
                        >
                            {tipoIdentificacionValues.map((tipo) => (
                                <MenuItem key={tipo} value={tipo}>
                                    {tipo}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        required
                        fullWidth
                        label="Número"
                        value={numeroIdentificacion}
                        onChange={(e) => setNumeroIdentificacion(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        required
                        fullWidth
                        label="Expedida en"
                        value={expedidaEn}
                        onChange={(e) => setExpedidaEn(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <DatePicker
                                label="Fecha de expedición"
                                sx={{ width: '100%' }}
                                value={fechainicial}
                                onChange={(newValue) => { setfechainicial(newValue); }}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        required
                        fullWidth
                        label="Dirección"
                        value={direccion}
                        onChange={(e) => setDireccion(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        required
                        fullWidth
                        label="Ciudad"
                        value={ciudad}
                        onChange={(e) => setCiudad(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <TextField
                        required
                        fullWidth
                        label="Teléfono"
                        inputProps={{
                            pattern: "[0-9]*", // Expresión regular para permitir solo dígitos
                        }}
                        value={telefono}
                        onChange={(e) => setTelefono(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        required
                        fullWidth
                        label="Celular"
                        inputProps={{
                            pattern: "[0-9]*", // Expresión regular para permitir solo dígitos
                        }}
                        value={celular}
                        onChange={(e) => setCelular(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <TextField
                        required
                        fullWidth
                        label="E-mail"
                        value={email}
                        type={"email"}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <Alert severity="warning">Si no poseen o no deben cumplir con un estado de resultados, se diligencie en las casillas N/A.</Alert>
                </Grid>

                <Grid item xs={12}>
                    <Typography style={{ textAlign: "initial" }}>Renta </Typography>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <Typography style={{ textAlign: "initial" }}>Responsable:
                        <Checkbox
                            checked={responsableRentaCheck}
                            onChange={(e) => {
                                setResponsableRentaCheck(e.target.checked)
                            }}
                        />
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <Typography style={{ textAlign: "initial" }}>Renta:
                        <Checkbox
                            checked={rentaCheck}
                            onChange={(e) => {
                                setRentaCheck(e.target.checked)
                            }}
                        />
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <TextField
                        required={rentaCheck}
                        fullWidth
                        label="Resolución No"
                        value={rentaResolucion}
                        onChange={(e) => setRentaResolucion(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <DatePicker
                                label="Fecha de expedición"
                                sx={{ width: '100%' }}
                                value={fechaRenta}
                                onChange={(newValue) => { setFechaRenta(newValue); }}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12}>
                    <Typography style={{ textAlign: "initial" }}>IVA: </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Typography style={{ textAlign: "initial" }}>Régimen común:
                        <Checkbox
                            checked={regimenCheck}
                            onChange={(e) => {
                                setReegimenCheck(e.target.checked)
                            }}
                        />
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography style={{ textAlign: "initial" }}>Régimen simple:
                        <Checkbox
                            checked={!regimenCheck}
                            onChange={(e) => {
                                setReegimenCheck(!e.target.checked)
                            }}
                        />
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Typography style={{ textAlign: "initial" }}>ICA: </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Ciudad"
                        value={ciudadIca}
                        onChange={(e) => setCiudadIca(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Tarifa x 1000"
                        value={tarifaPorMil}
                        inputProps={{
                            pattern: "[0-9]*",
                        }}
                        onChange={(e) => setTarifaPorMil(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Typography style={{ textAlign: "initial", alignSelf: "center" }}>Autorretenedor:
                        <Checkbox
                            checked={autoRetenedorCheckIca}
                            onChange={(e) => {
                                setAutoRetenedorCheckIca(e.target.checked)
                            }}
                        />
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        required={autoRetenedorCheckIca}
                        fullWidth
                        label="Resolución No"
                        value={icaResolucion}
                        onChange={(e) => setIcaResolucion(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <DatePicker
                                label="Fecha de expedición"
                                sx={{ width: '100%' }}
                                value={fechaIca}
                                onChange={(newValue) => { setFechaIca(newValue); }}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">Información financiera</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        required
                        fullWidth
                        label="Total activos"
                        value={totalActivos}
                        onChange={(e) => setTotalActivos(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        required
                        fullWidth
                        label="Total pasivos"
                        value={totalPasivos}
                        onChange={(e) => setTotalPasivos(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        required
                        fullWidth
                        label="Patrimonio"
                        value={patrimonio}
                        onChange={(e) => setPatrimonio(e.target.value)}
                    />
                </Grid>


                <Grid item xs={12}>
                    <Typography variant="h6">Actividad en operaciones internacionales</Typography>
                </Grid>
                <Grid item xs={12} sm={6} style={{ textAlign: "initial", alignSelf: "center" }}>
                    <Typography variant="body1">3- ¿Realiza transacciones en moneda extranjera?
                        <Checkbox
                            checked={checkRealizaTransaccionesMonedaExtra}
                            onChange={(e) => {
                                setCheckRealizaTransaccionesMonedaExtra(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel id="tipo-transaccion-label">Tipo de Transacción</InputLabel>
                        <Select
                            labelId="tipo-transaccion-label"
                            required={checkRealizaTransaccionesMonedaExtra}
                            fullWidth
                            label="Tipo de Transacción"
                            value={tipoTransaccion}
                            onChange={(e) => setTipoTransaccion(e.target.value)}
                        >
                            {tipoTransaccionValue.map((tipo) => (
                                <MenuItem key={tipo} value={tipo}>
                                    {tipo}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>


                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Tipo de Producto</TableCell>
                                <TableCell>Monto</TableCell>
                                <TableCell>País</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.map((row, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    <TableCell>
                                        <TextField
                                            value={row.tipoProducto}
                                            onChange={(event) => handleCellChange(event, rowIndex, 'tipoProducto')}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            type="number"
                                            value={row.monto}
                                            onChange={(event) => handleCellChange(event, rowIndex, 'monto')}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={row.pais}
                                            onChange={(event) => handleCellChange(event, rowIndex, 'pais')}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Button variant="contained" color="primary" onClick={handleCopyRow}>
                        Añadir fila
                    </Button>
                </TableContainer>


                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth required>
                        <InputLabel id="categoria-label">Categoría de producto o servicio que suministra</InputLabel>
                        <Select
                            labelId="categoria-label"
                            label="Categoría de producto o servicio que suministra"
                            value={categoria}
                            onChange={(e) => setCategoria(e.target.value)}
                        >
                            <MenuItem value="SERVICIOS DE TRANSPORTE NACIONAL">SERVICIOS DE TRANSPORTE NACIONAL</MenuItem>
                            <MenuItem value="SERVICIOS INFORMÁTICOS">SERVICIOS INFORMÁTICOS</MenuItem>
                            <MenuItem value="SERVICIOS MECANIZADOS O METALMECÁNICOS">SERVICIOS MECANIZADOS O METALMECÁNICOS</MenuItem>
                            <MenuItem value="SERVICIOS DE AGENCIA DE ADUANAS">SERVICIOS DE AGENCIA DE ADUANAS</MenuItem>
                            <MenuItem value="SERVICIOS DE TRANSPORTE INTERNACIONAL">SERVICIOS DE TRANSPORTE INTERNACIONAL</MenuItem>
                            <MenuItem value="SERVICIOS DE PAQUETEO">SERVICIOS DE PAQUETEO</MenuItem>
                            <MenuItem value="SERVICIOS DE INGENIERÍA">SERVICIOS DE INGENIERÍA</MenuItem>
                            <MenuItem value="SERVICIOS LEGALES">SERVICIOS LEGALES</MenuItem>
                            <MenuItem value="SERVICIOS CONTABLES E IMPUESTOS">SERVICIOS CONTABLES E IMPUESTOS</MenuItem>
                            <MenuItem value="SERVICIOS LOGÍSTICOS">SERVICIOS LOGÍSTICOS</MenuItem>
                            <MenuItem value="SUMINISTROS MATERIAS PRIMAS">SUMINISTROS MATERIAS PRIMAS</MenuItem>
                            <MenuItem value="SUMINISTROS MATERIAL DE EMPAQUE">SUMINISTROS MATERIAL DE EMPAQUE</MenuItem>
                            <MenuItem value="SUMINISTROS REPUESTOS">SUMINISTROS REPUESTOS</MenuItem>
                            <MenuItem value="SUMINISTROS MAQUINARIA Y EQUIPOS PARA LA VENTA">SUMINISTROS MAQUINARIA Y EQUIPOS PARA LA VENTA</MenuItem>
                            <MenuItem value="SUMINISTROS DE CONSUMIBLES Y ACCESORIOS PARA LA VENTA">SUMINISTROS DE CONSUMIBLES Y ACCESORIOS PARA LA VENTA</MenuItem>
                            <MenuItem value="ALMACENAMIENTO">ALMACENAMIENTO</MenuItem>
                            <MenuItem value="ENSAYOS DE LABORATORIO">ENSAYOS DE LABORATORIO</MenuItem>
                            <MenuItem value="SELLOS DE SEGURIDAD">SELLOS DE SEGURIDAD</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>


                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9" >1- ¿Usted es funcionario público o ha sido funcionario público en los últimos dos (2) años?
                        <Checkbox
                            checked={funcionarioPublico}
                            onChange={(e) => {
                                setFuncionarioPublico(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        />
                    </Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">2- ¿Usted actualmente administra recursos públicos o los ha administrado durante los últimos dos (2) años?
                        <Checkbox
                            checked={administraRecursosPublicos}
                            onChange={(e) => {
                                setAdministraRecursosPublicos(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">3- ¿Usted goza de reconocimiento público en alguna comunidad?
                        <Checkbox
                            checked={reconocimientoPublico}
                            onChange={(e) => {
                                setReconocimientoPublico(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>



                <Grid item xs={12} sm={12}>
                    <TextField
                        fullWidth
                        label="otro"
                        value={otroTipo}
                        onChange={(e) => setOtroTipo(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">Datos de la Oficina Principal</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Dirección Oficina Principal" value={direccionOficinaPrincipal} onChange={(e) => setDireccionOficinaPrincipal(e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField fullWidth label="Ciudad Oficina Principal" value={ciudadOficinaPrincipal} onChange={(e) => setCiudadOficinaPrincipal(e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField fullWidth label="País Oficina Principal" value={paisOficinaPrincipal} onChange={(e) => setPaisOficinaPrincipal(e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Teléfono Principal" value={telefonoPrincipal} onChange={(e) => setTelefonoPrincipal(e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth type="email" label="Correo Comercial" value={correoComercial2} onChange={(e) => setCorreoComercial2(e.target.value)} />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">Datos de la Sucursal / Agencia</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Dirección Sucursal" value={direccionSucursal} onChange={(e) => setDireccionSucursal(e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField fullWidth label="Ciudad Sucursal" value={ciudadSucursal} onChange={(e) => setCiudadSucursal(e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField fullWidth label="País Sucursal" value={paisSucursal} onChange={(e) => setPaisSucursal(e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Teléfono Sucursal" value={telefonoSucursal} onChange={(e) => setTelefonoSucursal(e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth type="email" label="Correo Pagos" value={correoPagos} onChange={(e) => setCorreoPagos(e.target.value)} />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">Declaración de origen de fondos y autorización de consulta en centrales de riegos</Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Typography variant="caption" >Declaro (amos) que: (i) nuestro (s) recursos y bienes son de procedencia lícita y no están vinculados a la comisión de delitos relacionados con el lavado de activos, la financiación del terrorismo, tráfico de armas y la promoción o financiación de armas de destrucción masiva, y provienen concretamente de



                        : <b>{nombreEmpresa.toUpperCase()} </b> ;
                        (ii) que los productos, bienes o servicios que comercializamos con C.I. TALSA no son utilizados para ser destinados a la comisión de delitos, al lavado de activos, a la financiación del terrorismo, al tráfico de armas, a la financiación o promoción de armas de destrucción masiva y en general, a ninguna actividad ilícita; (iii) que nuestra empresa no ha sido condenado (a) ni está siendo investigado (a) por la presunta comisión de delitos relacionados con el lavado de activos, la financiación del terrorismo, el tráfico de armas, financiación de armas de destrucción masiva y delitos similares o conexos; (iv) no me encuentro (no nos encontramos) incluido (s) en listas para el control del lavado de activos, la financiación del terrorismo, el tráfico de armas y la financiación o promoción de armas de destrucción masiva, administradas por cualquier autoridad nacional o extranjera, tales como la lista de la Oficina de Control de Activos Extranjeros (OFAC) del Departamento del Tesoro de los Estados Unidos de América, la lista de la ONU y otras listas similares; (v) De la misma forma, tampoco mis (nuestros) socios, representantes, directivos y miembros de junta se encuentran incluidos en las referenciadas listas para el control del lavado de activos, la financiación del terrorismo, el tráfico de armas, la financiación o promoción de armas de destrucción masiva; y (vi) implemente (implementamos) las medidas que por ley me (nos) corresponden para la prevención, detección y administración del riesgo de lavado de activos, el tráfico de armas, la financiación o promoción de armas de destrucción masiva y financiación del terrorismo. FACULTAD DE TERMINACIÓN UNILATERAL: Facultamos a C.I. TALSA para qué en cualquier momento de nuestra relación comercial, si llegaré o llegásemos a incurrir en alguna de las circunstancias descritas en la DECLARACIÓN SOBRE PREVENCIÓN DE LAVADO DE ACTIVOS Y FINANCIACIÓN DEL TERRORISMO Y EL FINANCIAMIENTO DE LA PROLIFERACIÓN DE ARMAS DE DESTRUCCIÓN MASIVA (LA/FT): de por terminado unilateralmente el contrato, acuerdo, oferta, o cualquier negocio jurídico existente entre las partes para ese momento.</Typography>
                </Grid>


                <Grid item xs={12}>
                    <Typography variant="h6">Autorización para consulta y reporte de información</Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Typography variant="caption">El (los) abajo firmante (s) actuando en nombre propio y/o en representación de la sociedad,  <b>{nombreEmpresa.toUpperCase()} </b>, autorizo a CI TECNOLOGÍA ALIMENTARIA S.A.S "TALSA", de manera irrevocable, escrita, expresa, concreta, suficiente, voluntaria e informada, para que toda la información personal, actual y la que genere en el futuro, fruto de las relaciones comerciales y/o contractuales establecidas con "TALSA", referente a mi comportamiento financiero, crediticio, origen de fondos, comercial y de servicios que exista o pueda existir en base de datos, centrales de riesgo o de información, nacionales o extranjeras, especialmente aquella referida al nacimiento, ejecución y extinción de obligaciones que directa o indirectamente tengan carácter de dinerarias, independientemente de la naturaleza del contrato que les de origen sea administrada, capturada, procesada, operada, verificada, usada y consultada. Igualmente autorizo a TALSA a entregar mi información de forma verbal, escrita o puesta a disposición de terceras personas, a las autoridades administrativas y judiciales que lo requieran, a los órganos de control y demás dependencias de investigación disciplinaria, fiscal o administrativa cuando sea solicitada en desarrollo de una investigación, a otros operadores cuando tengan una finalidad similar a la que tiene el operador que entrega los datos.                                                                                                                                                                                                                                                                                                                                                                                                        Bajo la gravedad del juramento certifico que los datos por mí suministrados son veraces, completos, exactos, actualizados y comprobables. Por tanto, cualquier error en la información suministrada por mí; será de mi única y exclusiva responsabilidad, lo que exonera a TALSA de su responsabilidad ante las autoridades judiciales y/o administrativas para la información aquí consignada.</Typography>
                </Grid>


                <Grid item xs={12} style={{ textAlign: "justify" }} >
                    <Typography variant="caption" ></Typography>
                    Como constancia de haber leído, entendido y aceptado lo anterior, declaro que la información que he suministrado a CI TECNOLOGÍA ALIMENTARIA S.A.S. es exacta en todas sus partes, firmo el presente documento a los <b> {currentDate.getDay()}</b> días del mes de <b> {currentDate.getMonth()}</b> del año <b>{currentDate.getFullYear()}</b>   , en la ciudad de <b>{sucursalValue}</b>.
                </Grid>


                <Grid item xs={12}>
                    <Alert severity="warning">Si el proveedor que es persona natural , no cuenta con cámara de comercio o declaración de renta, se debe anexar una carta en los mismos campos donde lo especifique y debe estar firmada.</Alert>
                </Grid>


                <Grid item xs={12}>
                    <Typography variant="h6">Documentos requeridos</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor="RUT">RUT</InputLabel>
                    <TextField
                        fullWidth
                        required
                        accept="application/pdf"
                        type="file"
                        onChange={handleRutChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor="Cámara de comercio">Cámara de comercio</InputLabel>
                    <TextField
                        required
                        fullWidth
                        accept="application/pdf"
                        type="file"
                        onChange={handleCamaraComercioChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <InputLabel htmlFor="Fotocopia de CC / ID del representante legal al 150%">Fotocopia de CC / ID del representante legal al 150%</InputLabel>
                    <TextField
                        required
                        variant="outlined"
                        accept="application/pdf"
                        fullWidth
                        type="file"
                        onChange={handleCcIdRepresentanteChange}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor="Certificación bancaria">Certificación bancaria</InputLabel>
                    <TextField
                        required
                        variant="outlined"
                        accept="application/pdf"
                        fullWidth
                        type="file"
                        onChange={handleCertificacionBancariaChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <InputLabel htmlFor="Declaración de renta del último periodo gravable disponible">Declaración de renta del último periodo gravable disponible
                    </InputLabel>
                    <TextField
                        required
                        variant="outlined"
                        accept="application/pdf"
                        fullWidth
                        type="file"
                        onChange={handlePolizaSeguroChange}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        required
                        fullWidth
                        label="Nombre solicitante"
                        value={nombreSolicitante}
                        onChange={(e) => setNombreSolicitante(e.target.value)}
                    />
                </Grid><Grid item xs={4}>
                    <TextField
                        required
                        fullWidth
                        label="Firma"
                        value={Firma}
                        onChange={(e) => setFirma(e.target.value)}
                    />
                </Grid><Grid item xs={4}>
                    <TextField
                        required
                        fullWidth
                        label="Documento"
                        value={documentoFirma}
                        onChange={(e) => setDocumentoFirma(e.target.value)}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        required
                        fullWidth
                        label="Nombre del empleado TALSA"
                        value={EmpleadoTalsa}
                        onChange={(e) => setEmpleadoTalsa(e.target.value)}
                    />
                </Grid>



                <Grid item xs={12} style={{ textAlign: "justify" }} >
                    <div>
                        <SignatureCanvas
                            canvasProps={{
                                width: 550,
                                height: 150,
                                style: { "border": "1px solid #000000" }
                            }}
                            minWidth={1}
                            maxWidth={1}
                            penColor="black"
                            ref={sigPad}
                        />
                        <br /><Button onClick={() => {
                            sigPad.current.clear()
                            setFirmaFile(null)
                        }}
                            variant="contained"
                            component="label"
                            color="primary"
                            style={{ margin: "10px" }}>
                            Limpiar     </Button>
                        <Button variant="contained"
                            component="label"
                            color="primary"
                            style={{ margin: "10px" }} onClick={() => {
                                const canvas = sigPad.current.getCanvas();
                                const base64Data = canvas.toDataURL(); // Obtener el valor base64 de la imagen dibujada
                                setFirmaFile(base64Data)
                                swal("Gracias", "Firma ingresada con exito", "success");
                            }}>Guardar</Button>
                    </div>
                </Grid>

                <Alert severity="warning">Debe de firmar el formulario y luego darle al boton enviar información.</Alert>

                <Grid item xs={12}>

                    <LoadingButton
                        onClick={handleSubmit}
                        loading={loading}
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                        variant="outlined">
                        Enviar información
                    </LoadingButton>
                </Grid>
            </Grid>
        </form >
    );
}

